import { z } from 'zod';

// ── Tip Config Schemas — JQ4-37 · US-PAGOS-003 · Configurable Tips ───────────
//
// Admin endpoints: GET/PUT /admin/locations/:locationId/tip-config
// Visitor endpoint: tipConfig field added to PaymentConfigResponse (payment-schemas.ts)
//
// Decision: MAX_CUSTOM_TIP_CENTS = 50000 ($500) — hard cap, fat-finger guard.
// Decision: suggestedPercentages max 6 entries, range [1, 100], dedup+sort in use case.

export const MAX_TIP_PERCENTAGE = 100;
export const MAX_CUSTOM_TIP_CENTS = 50000; // $500 hard cap

export const TipPercentageSchema = z.number().int().min(1).max(MAX_TIP_PERCENTAGE);

// ── Admin PUT request ─────────────────────────────────────────────────────────

export const UpdateTipConfigRequestSchema = z.object({
  tipsEnabled: z.boolean(),
  /** 0–6 integer values in [1, 100]. Dedup + sort applied server-side. */
  suggestedPercentages: z.array(TipPercentageSchema).max(6),
  customAllowed: z.boolean(),
});

export type UpdateTipConfigRequest = z.infer<typeof UpdateTipConfigRequestSchema>;

// ── Admin GET/PUT response ────────────────────────────────────────────────────

export const TipConfigResponseSchema = z.object({
  locationId: z.string().uuid(),
  organizationId: z.string().uuid(),
  tipsEnabled: z.boolean(),
  suggestedPercentages: z.array(z.number().int()),
  customAllowed: z.boolean(),
  /** ISO string when a row exists; null when returning defaults (no row persisted yet). */
  updatedAt: z.string().nullable(),
});

export type TipConfigResponse = z.infer<typeof TipConfigResponseSchema>;
